export default [
  { id: 1, 작업내용: '기계설비공사',
    유해위험요인: '자재반입 및 하역 시 지게차 운전 미숙으로 인해 \n지게차에 충돌',
    개선대책: '1. 지게차로 반입 시 운전자의 자격여부 사전 확인',
  },
  { id: 2, 작업내용: '기계설비공사',
    유해위험요인: '안전모, 안전화 등 개인보호구를 미착용한 상태로 자재 하역, 운반 중 반입 자재에 끼임',
    개선대책: '1. 자재반입, 운반작업 중 개인보호구 착용 철저',
  },
  { id: 3, 작업내용: '기계설비공사',
    유해위험요인: '유도자를 미배치한 상태에서 지게차 작업 중 주변 근로자와 충돌',
    개선대책: '1.  지게차 사용 시 유도자 배치\n' +
      '2. 근로자 출입 통제',
  },
  { id: 4, 작업내용: '기계설비공사',
    유해위험요인: '불안전한 적재로 인한 붕괴',
    개선대책: '1. 자재 적재 시 평탄하고 견고한 지반에 적재',
  },
  { id: 5, 작업내용: '기계설비공사',
    유해위험요인: '설비 보온재 작업 중 주변 용접 불티 비산으로 인한 화재 발생',
    개선대책: '1. 인화성 자재 주변에서 용접 금지\n' +
      '2. 소화기 비치',
  },
  { id: 6, 작업내용: '기계설비공사',
    유해위험요인: '파이브 배관 절단작업 중 고속절단기 누전에 의한 감전',
    개선대책: '1. 공도구 사용 전 점검\n' +
      '2. 누전차단기 설치, 접지선 연결',
  },
  { id: 7, 작업내용: '기계설비공사',
    유해위험요인: '교류 아크용접기를 사용하여 자재 용접 작업 중 \n자동전격방지기 미설치로 인한 감전',
    개선대책: '1. 교류 아크용접기 사용 시\n' +
      '2. 자동전격방지기 설치',
  },
  { id: 8, 작업내용: '기계설비공사',
    유해위험요인: 'LPG 및 산소용기를 밀폐된 공간에서 사용 증 \n가스누출로 인한 폭발',
    개선대책: '1. 환기가 잘되는 장소에 LPG 및 산소용기 비치 \n' +
      '2. 사용 전 가스 누출여부 확인',
  },
  { id: 9, 작업내용: '기계설비공사',
    유해위험요인: '인력으로 소운반 중 바닥의 돌출물에 걸려 넘어짐',
    개선대책: '1. 소운반 시 운반대차에 자재를 적재하여 운반\n' +
      '2. 운반로 정리정돈 철저',
  },
  { id: 10, 작업내용: '기계설비공사',
    유해위험요인: '지게차로 기계설비 자재 운반 중 자재 낙하',
    개선대책: '1. 지게차로 자재 운반 시 파레트 등 얹어 결속 후 운반',
  },
  { id: 11, 작업내용: '기계설비공사',
    유해위험요인: '운반작업 구간에 근로자 접근 방지 조치 미실시로 인해 자재가 넘어지면서 끼임',
    개선대책: '1. 설비자재 운반작업 구간에 근로자 접근 방지',
  },
  { id: 12, 작업내용: '기계설비공사',
    유해위험요인: '기계 설비작업 구간에 접근방지 조치 미실시로 주변 근로자 끼임',
    개선대책: '1. 기계설비 작업구간 작업관계자 외 접근금지 조치',
  },
  { id: 13, 작업내용: '기계설비공사',
    유해위험요인: '사다리 설치 후 배관작업 중 사다리 쓰러짐으로 \n인한 떨어짐',
    개선대책: '1. 배관, 덕트 설치 시 이동식 비계 설치하여 작업실시',
  },
  { id: 14, 작업내용: '기계설비공사',
    유해위험요인: '천정 설치 작업 시 자재 균형잃고 낙하',
    개선대책: '1. 상향 설치작업 시 받침대나 로프로 결속 후 작업 실시',
  },
]
